
import Vue from 'vue'
import { EditorContent } from '@tiptap/vue-2'
import TiptapMixin from '@/mixins/tiptap'

export default Vue.extend({
  name: 'Tiptap',
  components: { EditorContent },
  mixins: [TiptapMixin],
  props: {
    content: {
      required: true,
      type: String
    },
    disableClasses: {
      type: Boolean,
      default: false
    }
  }
})

